import React from 'react'
import starfall from '../assets/img/star-fall.svg'
import bank from '../assets/img/bank-airdrop.png'
import decrease from '../assets/img/decrease-airdrop.png'
import { SlArrowRight } from "react-icons/sl";

export const DailyAirdrops = () => {
    const airdropsData = [
        {id: 1, title: 'Запуск пула', link_data: 'Ставка для получения потенциальных токенов проекта', url: bank, benefit: '1,000% APR*', benefit_info: '*Самая высокая годовая процентная ставка за все время'},
        {id: 2, title: 'Кикстартер', link_data: 'Удерживайте MX, чтобы получать бесплатный airdrop каждый день', url: decrease, benefit: '23,87% годовых'},
    ]
  return (
    <div id="daily-airdrops">
        <div className="container">
            <div className="daily-airdrops">
                <div className="heading">
                    <h1>Ежедневные аирдропы</h1>
                    <div className="big-grey">Присоединяйтесь к событиям по аирдропу и получайте APR до 1 000%</div>
                </div>
                <div className="cards">
                    {
                        airdropsData.map(airdrop => (
                            <div className="airdrop" key={airdrop.id}>
                                <div className="airdrop-upper">
                                    <div className="airdrop-title"><img src={starfall} alt="" /> {airdrop.title}</div>
                                    <div className="airdrop-link">{airdrop.link_data} <SlArrowRight size={16} /></div>
                                </div>
                                <div className="airdrop-img">
                                        <img src={airdrop.url} alt="" />
                                </div>
                                <div className="airdrop-txt">
                                    <div className="airdrop-benefit">{airdrop.benefit}</div>
                                    <div className="airdrop-link">{airdrop.benefit_info}</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    </div>
  )
}
